<template>
  <v-container
    fluid
    class="px-0 pt-1 page-container"
    :class="isUnionPortal ? 'mt-3 ' : ''"
  >
    <v-row no-gutters v-if="!loadingUserProfile && isUserAllowedToLogin">
      <v-col
        class="pa-0 pb-1"
        :class="
          $vuetify.breakpoint.mdAndUp
            ? isUnionPortal
              ? 'pa-sm-4'
              : 'pa-sm-2'
            : 'pa-1'
        "
        v-for="item in itemsToShow"
        :key="item.Id"
        :order="item.Order"
        cols="12"
        :md="item.Name === 'BenefitCardsDashboardItemSba' ? 12 : 6"
        :sm="item.Name === 'BenefitCardsDashboardItemSba' ? 12 : 6"
        :lg="item.Size"
      >
        <!-- add draggable to above to enable drag and drop -->
        <component
          v-if="checkRole(item)"
          :is="item.Name"
          :size.sync="item.Size"
          :height="role === 'Trustee' ? 3 : item.Height"
          :widgetIcon="item.WidgetIcon"
          :image="item.Image"
          :text="item.Text"
          :order="item.Order"
          :maxOrderValue="items.length - 1"
          @update-order="updateOrder($event, item)"
          @add-widget="$emit('add-widget', $event)"
          @remove-widget="$emit('remove-widget', $event)"
          @send-message="$emit('send-message', $event)"
          @view-pdf="openPdf($event)"
          :widgetId="item.Id"
          :id="`dashboard_item-${item.Order}`"
          :sending="sending"
        />
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        indeterminate
        class="mt-10"
        color="primary"
      ></v-progress-circular>
    </v-row>

    <!-- Global Search -->
    <!-- <v-container class="px-0 px-sm-4">
      <v-row no-gutters justify="center">
        <v-menu
          max-height="60vh"
          :value.sync="isSearchFound"
          top
          offset-y
          transition="expand-transition"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              clearable
              v-model="search"
              class="search"
              prepend-inner-icon="mdi-magnify"
              :label="$t('views.page.home.search')"
              single-line
              hide-details
              outlined
              @keydown="on.click"
              @input="triggerSearch = !triggerSearch"
            ></v-text-field>
          </template>

          <global-search-results
            :search="search"
            :triggerSearch="triggerSearch"
            @search-found="isSearchFound = $event"
            @view-pdf="openPdf($event)"
            @clear-search="search = null"
          />
        </v-menu>
      </v-row>
    </v-container> -->

    <!-- <v-dialog v-model="showPdf">
      <transition name="transition-anim">
        <section class="pdf-preview" v-if="pdfSource">
          <button @click.self="closePdfViewer()">&times;</button>
          <iframe :src="pdfSource" width="100%" height="100%" />
        </section>
      </transition>
    </v-dialog> -->
    <v-dialog
      persistent
      hide-overlay
      scrollable
      v-if="pdfSource"
      v-model="showPdf"
      :width="$vuetify.breakpoint.mdAndDown ? '100%' : '80%'"
    >
      <v-card height="80vh" color="secondary">
        <v-card-title :class="`pa-0 pl-4 text-subtitle-1 white--text`">
          {{ pdfTitle }}
          <v-spacer></v-spacer>
          <v-btn icon large @click="closePdfViewer()" class="text-right" dark>
            <v-icon>mdi-close-thick</v-icon>
          </v-btn>
        </v-card-title>
        <pdf-view :source="pdfSource" />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { forExternalPension } from "@/plugins/externalPension";
import { forCardPayments } from "@/plugins/cardPayments";
import BenefitBalanceDashboardItem from "./dashboardItems/BenefitBalanceDashboardItem.vue";
import DependantsDashboardItem from "./dashboardItems/DependantsDashboardItem.vue";
import DownloadsDashboardItem from "./dashboardItems/DownloadsDashboardItem.vue";
import MyDocumentsDashboardItem from "./dashboardItems/MyDocumentsDashboardItem.vue";
import FaqDashboardItem from "./dashboardItems/FaqDashboardItem.vue";
import RecentActivityDashboardItem from "./dashboardItems/RecentActivityDashboardItem.vue";
import WelcomeDashboardItem from "./dashboardItems/WelcomeDashboardItem.vue";
import NewsDashboardItem from "./dashboardItems/NewsDashboardItem.vue";
import PensionSummaryDashboardItem from "./dashboardItems/PensionSummaryDashboardItem.vue";
import MyPensionDashboardItem from "./dashboardItems/MyPensionDashboardItem.vue";
import CcwippLoadingDashboardItem from "./dashboardItems/CcwippLoadingDashboardItem.vue";
import MyLifeEventsDashboardItem from "./dashboardItems/MyLifeEventsDashboardItem.vue";
import MyBalanceDashboardItem from "./dashboardItems/MyBalanceDashboardItem.vue";
import AddWidgetDashboardItem from "./dashboardItems/AddWidgetDashboardItem.vue";
import AssistantDashboardItem from "./dashboardItems/AssistantDashboardItem.vue";
import BeneficiariesDashboardItem from "./dashboardItems/BeneficiariesDashboardItem.vue";
import MemberInformationDashboardItem from "./dashboardItems/MemberInformationDashboardItem.vue";
import MyInfoDashboardItem from "./dashboardItems/MyInfoDashboardItem.vue";
import MyInfoDashboardItemSba from "./dashboardItems/MyInfoDashboardItemSba.vue";
import MyClaimDashboardItemSba from "./dashboardItems/MyClaimDashboardItemSba.vue";
import DrugProviderSearchDashboardItemSba from "./dashboardItems/DrugProviderSearchDashboardItemSba.vue";
import BenefitCardsDashboardItemSba from "./dashboardItems/BenefitCardsDashboardItemSba.vue";
import UsedBenefitsDashboardItemSba from "./dashboardItems/UsedBenefitsDashboardItemSba.vue";
import RecentClaims from "./dashboardItems/RecentClaims.vue";
// import LocalsLocationsDashboardItem from "./dashboardItems/LocalsLocationsDashboardItem.vue";
import UsedBenefitsDashboardItemSbaLegacy from "./dashboardItems/UsedBenefitsDashboardItemSbaLegacy.vue";
import DocumentsDashboardItemSba from "./dashboardItems/DocumentsDashboardItemSba.vue";
import HSADashboardItemSba from "./dashboardItems/HSADashboardItemSba.vue";
import HoursBankDashboardItem from "./dashboardItems/HoursBankDashboardItem.vue";
import ContactDashboardItem from "./dashboardItems/ContactDashboardItem.vue";
import EmptyDashboardItem from "./dashboardItems/EmptyDashboardItem.vue";
import GlobalSearchResults from "@/components/VueMaterialDashboard/GlobalSearchResults.vue";
import PdfView from "@/components/DownloadCentre/PdfView.vue";
import WellnessDashboardItemSba from "./dashboardItems/WellnessDashboardItemSba.vue";
import UsedBenefitsDashboardItem from "./dashboardItems/UsedBenefitsDashboardItem.vue";
import VirtualDoctorDashboardSba from "./dashboardItems/VirtualDoctorDashboardSba.vue";
import StudentAssistanceProgramSba from "./dashboardItems/StudentAssistanceProgramSba.vue";
import HealthCareInformationDashboardItemSba from "./dashboardItems/HealthCareInformationDashboardItemSba.vue";
import ExternalPensionDashboardItem from "./dashboardItems/ExternalPensionDashboardItem.vue";

export default {
  components: {
    BenefitBalanceDashboardItem,
    DependantsDashboardItem,
    DownloadsDashboardItem,
    MyDocumentsDashboardItem,
    FaqDashboardItem,
    RecentActivityDashboardItem,
    WelcomeDashboardItem,
    NewsDashboardItem,
    PensionSummaryDashboardItem,
    MyPensionDashboardItem,
    CcwippLoadingDashboardItem,
    MyLifeEventsDashboardItem,
    MyBalanceDashboardItem,
    AddWidgetDashboardItem,
    AssistantDashboardItem,
    BeneficiariesDashboardItem,
    MemberInformationDashboardItem,
    MyInfoDashboardItem,
    MyInfoDashboardItemSba,
    MyClaimDashboardItemSba,
    BenefitCardsDashboardItemSba,
    DrugProviderSearchDashboardItemSba,
    DocumentsDashboardItemSba,
    // LocalsDashboardItem,
    // MembershipsDashboardItem,
    // UpcomingEventsDashboardItem,
    // UnionDocumentsDashboardItem,
    // LocalsLocationsDashboardItem,
    HSADashboardItemSba,
    HoursBankDashboardItem,
    UsedBenefitsDashboardItemSba,
    UsedBenefitsDashboardItemSbaLegacy,
    RecentClaims,
    ContactDashboardItem,
    EmptyDashboardItem,
    GlobalSearchResults,
    PdfView,
    WellnessDashboardItemSba,
    UsedBenefitsDashboardItem,
    VirtualDoctorDashboardSba,
    StudentAssistanceProgramSba,
    HealthCareInformationDashboardItemSba,
    ExternalPensionDashboardItem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    sending: Boolean,
  },
  data() {
    return {
      search: null,
      isSearchFound: false,
      triggerSearch: false,
      pdfSource: null,
      pdfTitle: null,
      showPdf: false,
      isUserAllowedToLogin: false,
      allowedAccountStatuses: [
        "active",
        "qualifying period",
        "deferred",
        "terminated",
        "paid",
        "retired",
        "non-participant",
      ],
      memberSpendingAccounts: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["role", "user"]),
    ...mapGetters("data", ["memberHasHSA", "memberHasWellness"]),
    ...mapGetters("common", [
      "isPensionsPortal",
      "isDemoMockPlan",
      "isUnionPortal",
      "useLegacyClaims",
      "userProfile",
      "hideFrequentlyUsed",
      "hasEligibilityBank",
      "dashboardLayoutRules",
      "isExternalPensionMember",
      "hasCardPayments",
      "hasDrugSearch",
      "hasProviderSearch",
    ]),
    // filtered at render time so the settings list is never saved back without these tiles
    memberItems() {
      const items = forCardPayments(
        forExternalPension(this.items, this.isExternalPensionMember),
        this.hasCardPayments
      );
      // with both searches off the search tile renders nothing, so it must not hold a grid slot
      return this.hasDrugSearch || this.hasProviderSearch
        ? items
        : items?.filter((i) => i.Name !== "DrugProviderSearchDashboardItemSba");
    },
    numberOfWidgetsInARow() {
      return this.$vuetify.breakpoint.mdAndUp
        ? 3
        : this.$vuetify.breakpoint.xsOnly
        ? 1
        : 2;
    },
    hasHealthLifestyle() {
      let result = false;
      if (!this.userProfile) {
        return result;
      }
      this.userProfile?.Coverages?.forEach((coverage) => {
        if (
          coverage?.CoverageIdentity?.CoverageType === "Health" &&
          coverage?.CurrentBenefit?.Name?.toLowerCase().includes("lifestyle")
        ) {
          result = true;
        }
      });
      return result;
    },
    loadingUserProfile() {
      return this.userProfile === null || this.userProfile === undefined;
    },
    itemsToShowLegacy() {
      let toShow = this.memberItems.filter((i) => {
        if (i.ShowTo) {
          if (this.isPensionsPortal) {
            if (this.loadingUserProfile) {
              return i.ShowTo.includes("Loading");
            }
            if (
              this.userProfile?.AccountStatus !== "Active" &&
              this.userProfile?.AccountStatus !== "Deferred" &&
              this.userProfile?.AccountStatus !== "Terminated" &&
              this.userProfile?.AccountStatus !== "Qualifying Period" &&
              this.userProfile?.AccountStatus !== "Non-Participant" &&
              i.Name === "MyLifeEventsDashboardItem"
            ) {
              return true;
            }

            return (
              i.ShowTo.includes(this.userProfile?.AccountStatus) ||
              i.ShowTo.includes("All")
            );
          }
          return i.ShowTo.includes(this.role);
        } else return true;
      });

      const usedBenefitsWidgetIndex = toShow.findIndex(
        (w) =>
          w.Name === "UsedBenefitsDashboardItemSba" || w.Name === "RecentClaims"
      );

      console.log("usedBenefitsWidgetIndex: ", usedBenefitsWidgetIndex, toShow);

      if (this.hasHealthLifestyle && usedBenefitsWidgetIndex !== -1) {
        toShow[usedBenefitsWidgetIndex].Name = "RecentClaims";
      }

      if (this.useLegacyClaims && usedBenefitsWidgetIndex !== -1) {
        toShow[usedBenefitsWidgetIndex].Name =
          "UsedBenefitsDashboardItemSbaLegacy";
      }

      if (usedBenefitsWidgetIndex !== -1 && this.hideFrequentlyUsed) {
        toShow = toShow.filter(
          (i) =>
            i.Name !== "UsedBenefitsDashboardItemSba" &&
            i.Name !== "UsedBenefitsDashboardItemSbaLegacy"
        );
      }

      console.log("hideFrequentlyUsed: ", this.hideFrequentlyUsed);

      const documentsWidgetIndex = toShow.findIndex(
        (w) => w.Name === "DocumentsDashboardItemSba"
      );

      const hsaWidgetIndex = toShow.findIndex(
        (w) => w.Name === "HSADashboardItemSba"
      );

      if (this.memberHasHSA) {
        if (hsaWidgetIndex !== -1 && documentsWidgetIndex !== -1) {
          if (this.hideFrequentlyUsed) {
            toShow[hsaWidgetIndex].Size = 4;
            toShow[documentsWidgetIndex].Size = 5;
          } else {
            toShow[usedBenefitsWidgetIndex].Size = 4;
          }
        }
      } else {
        toShow = toShow.filter((i) => i.Name !== "HSADashboardItemSba");
        if (this.hideFrequentlyUsed) {
          const documentsWidgetIndex = toShow.findIndex(
            (w) => w.Name === "DocumentsDashboardItemSba"
          );
          toShow[documentsWidgetIndex].Size = 9;
        }
      }
      if (!this.hasEligibilityBank) {
        toShow = toShow.filter((i) => i.Name !== "HoursBankDashboardItem");
      }
      if (this.hasEligibilityBank) {
        const hoursBankWidgetIndex = toShow.findIndex(
          (w) => w.Name === "HoursBankDashboardItem"
        );
        if (hoursBankWidgetIndex !== -1 && documentsWidgetIndex !== -1) {
          if (this.hideFrequentlyUsed) {
            toShow[hoursBankWidgetIndex].Size = 4;
            toShow[documentsWidgetIndex].Size = 5;
          } else {
            toShow[usedBenefitsWidgetIndex].Size = 4;
          }
        }
      }
      return toShow;
    },
    isRecentClaims() {
      return this.hasHealthLifestyle || this.memberHasOnlySpendingAccounts;
    },
    memberHasOnlySpendingAccounts() {
      if (!this.userProfile) {
        return false;
      }
      return !this.userProfile?.Coverages?.some(
        (o) => !o.IsHSA && !o.IsWellness
      );
    },
    itemsToShow() {
      if (
        this.dashboardLayoutRules === null ||
        this.dashboardLayoutRules === undefined ||
        !Array.isArray(this.dashboardLayoutRules) ||
        this.dashboardLayoutRules.length === 0
      ) {
        return this.itemsToShowLegacy;
      }
      let toShow = this.memberItems.filter((i) => {
        if (i.ShowTo) {
          if (this.isPensionsPortal) {
            if (this.loadingUserProfile) {
              return i.ShowTo.includes("Loading");
            }
            if (
              this.userProfile?.AccountStatus !== "Active" &&
              this.userProfile?.AccountStatus !== "Deferred" &&
              this.userProfile?.AccountStatus !== "Terminated" &&
              this.userProfile?.AccountStatus !== "Qualifying Period" &&
              this.userProfile?.AccountStatus !== "Non-Participant" &&
              i.Name === "MyLifeEventsDashboardItem"
            ) {
              return true;
            }

            return (
              i.ShowTo.includes(this.userProfile?.AccountStatus) ||
              i.ShowTo.includes("All")
            );
          }
          return i.ShowTo.includes(this.role);
        } else return true;
      });

      if (this.hideFrequentlyUsed && !this.isRecentClaims) {
        toShow = toShow.filter((i) => i.Name !== "UsedBenefitsDashboardItem");
      }

      if (!this.memberHasWellness) {
        toShow = toShow.filter((i) => i.Name !== "WellnessDashboardItemSba");
      }
      if (!this.memberHasHSA) {
        toShow = toShow.filter((i) => i.Name !== "HSADashboardItemSba");
      }
      const widgetNames = toShow.map((w) => w.Name);
      console.log(JSON.stringify(widgetNames));

      const matchingRules = this.dashboardLayoutRules.filter((rule) =>
        rule.condition.every((name) => widgetNames.includes(name))
      );

      if (matchingRules.length > 0) {
        matchingRules.sort((a, b) => b.condition.length - a.condition.length);

        const rule = matchingRules[0];
        Object.keys(rule.sizes).forEach((name) => {
          const widget = toShow.find((w) => w.Name === name);
          if (widget) {
            widget.Size = rule.sizes[name];
          }
        });
      }

      return toShow.filter((o) => o.Size > 0);
    },
  },
  watch: {
    userProfile: {
      handler(v) {
        if (v) {
          // Check if member is Neospin member and the member status is not in the allowed list
          if (this.isPensionsPortal && this.user?.neospinMemberId) {
            if (
              !this.allowedAccountStatuses.includes(
                this.userProfile?.AccountStatus?.toLowerCase()
              )
            ) {
              console.log(
                "user is not allowed to access this portal",
                this.user?.neospinMemberId,
                "AccountStatus: ",
                this.userProfile?.AccountStatus
              );
              this.isUserAllowedToLogin = false;
              this.$store.dispatch("auth/logout");
            } else {
              this.isUserAllowedToLogin = true;
            }
          } else {
            this.isUserAllowedToLogin = true;
          }
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    if (!this.isPensionsPortal) {
      await this.loadMemberSpendingAccounts();
      await this.getHasBeneficiariesFlag();
      // if (this.isDemoMockPlan) {
      //   this.setMockHSA(result);
      // }
    }
  },
  methods: {
    ...mapActions("data", [
      "getSpendingAccount",
      "setMockHSA",
      "getNeospinFile",
    ]),
    ...mapActions("common", ["getHasBeneficiariesFlag"]),
    async openPdf(item) {
      console.log("previewing document1", item);
      if (item.IsNeospinDocument) {
        try {
          this.loading = true;
          const res = await this.getNeospinFile({
            personId: item.NeospinDocument.PersonId,
            documentId: item.NeospinDocument.LaserficheID,
          });
          if (res.data.length > 0 && res.data[0].DocumentContent) {
            const data = this.b64toBlob(res.data[0].DocumentContent);
            const file = new Blob([data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            this.pdfSource = fileURL;
            this.pdfTitle =
              this.$vuetify.lang.current === "fr"
                ? item.NeospinDocument.PortalTypeFR
                : item.NeospinDocument.PortalType;
            this.pdfTitle = this.pdfTitle ?? "";
            this.showPdf = true;
          } else {
            this.error = {
              customMessage: this.$t(
                "components.download_centre.no_file_found"
              ),
            };
            return;
          }
        } catch (error) {
          console.log(error);
          this.error = {
            customMessage: this.$t("components.vue_downloads.download_error"),
          };
        } finally {
          this.loading = false;
        }
      } else {
        this.pdfSource =
          item["FileUrl" + this.$vuetify.lang.current.toUpperCase()];
        this.pdfTitle =
          item["Title" + this.$vuetify.lang.current.toUpperCase()];
        this.showPdf = true;
      }
    },
    async loadMemberSpendingAccounts() {
      try {
        const spendingAccounts = await this.getSpendingAccount({
          planIdentityId: this.user.plan,
          memberIdentityId: this.user.sub,
        });
        this.memberSpendingAccounts = spendingAccounts;
      } catch (error) {
        this.error = error;
      }
    },
    closePdfViewer() {
      this.showPdf = false;
      this.pdfSource = null;
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    updateOrder(itemInPositionOrder, item) {
      const newOrder = parseInt(itemInPositionOrder);

      if (isNaN(newOrder)) {
        return;
      }
      if (newOrder === item.Order) {
        return;
      }

      if (
        item.Height === 2 &&
        itemInPositionOrder >= this.items.length - this.numberOfWidgetsInARow
      ) {
        return;
      }

      const itemInPosition = this.items.find(
        (i) => i.Order === itemInPositionOrder
      );
      if (itemInPosition.Name === "EmptyDashboardItem") return;

      if (
        item.Order >= this.items.length - this.numberOfWidgetsInARow &&
        itemInPosition.Height === 2
      )
        return;
      itemInPosition.Order = item.Order;

      item.Order = newOrder;
      if (item.Height === 2) {
        const emptyWidget = this.items.find(
          (i) => i && i.Name === "EmptyDashboardItem"
        );
        const itemInPosition = newOrder + this.numberOfWidgetsInARow - 1;
        this.updateOrder(itemInPosition, emptyWidget);
      }

      if (itemInPosition.Height === 2) {
        const emptyWidget = this.items.find(
          (i) => i && i.Name === "EmptyDashboardItem"
        );
        const itemUnderTallWidget =
          itemInPosition.Order + this.numberOfWidgetsInARow - 1;
        this.updateOrder(itemUnderTallWidget, emptyWidget);
      }
    },

    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = "move";
      evt.dataTransfer.effectAllowed = "move";
      evt.dataTransfer.setData("id", item.Id);
      evt.dataTransfer.setData("x", evt.x);
      evt.dataTransfer.setData("y", evt.y);
      console.log("drag: ", evt, item);
    },

    onDrop(evt) {
      const id = evt.dataTransfer.getData("id");
      const item = this.items.find((item) => item.Id == id);
      const itemInPosition = this.getItemInPosition(evt.x, evt.y);
      console.log("dropped: ", evt, id, item, itemInPosition);

      if (
        item.Name === "AddWidgetDashboardItem" ||
        item.Name === "EmptyDashboardItem"
      )
        return;

      if (itemInPosition !== undefined) {
        const itemInPositionOrder = parseInt(itemInPosition.id.split("-")[1]);
        this.updateOrder(itemInPositionOrder, item);
      }
    },
    getItemInPosition(x, y) {
      let els = document.elementsFromPoint(x, y);
      console.log(els);
      let materialCardElements = els.filter((o) =>
        o.classList.contains("material-card")
      );
      if (materialCardElements.length === 1) {
        return materialCardElements[0];
      }
      return undefined;
    },
    checkRole(item) {
      if (item.ShowTo) {
        if (this.isPensionsPortal) {
          if (this.loadingUserProfile) {
            return item.ShowTo.includes("Loading");
          }
          if (item.ShowTo.includes(this.userProfile?.AccountStatus))
            return true;
          if (item.ShowTo.includes("All")) return true;
        }
        if (
          this.userProfile?.AccountStatus !== "Active" &&
          this.userProfile?.AccountStatus !== "Deferred" &&
          this.userProfile?.AccountStatus !== "Terminated" &&
          this.userProfile?.AccountStatus !== "Qualifying Period" &&
          this.userProfile?.AccountStatus !== "Non-Participant" &&
          !this.loadingUserProfile &&
          item.Name === "MyLifeEventsDashboardItem"
        ) {
          return true;
        }
        return item.ShowTo.includes(this.role);
      } else return true;
    },
  },
};
</script>
<style scoped>
.search {
  max-width: 1200px;
  margin: 20px auto auto;
}
.search >>> .v-input__slot {
  background-color: white !important;
  border-radius: 10px;
}
.search >>> fieldset {
  border: 2px solid rgb(189, 189, 189);
  border-radius: 10px;
}

@media screen and (max-width: 375px) {
  .search >>> .v-label {
    font-size: 14px;
  }
}
</style>
<style lang="scss" scoped>
.pdf-preview {
  position: fixed;
  width: 65%;
  min-width: 600px;
  height: 80vh;
  top: 100px;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0px 0px 10px #00000048;

  button {
    position: absolute;
    top: -20px;
    right: -15px;
    width: 35px;
    height: 35px;
    background: #555;
    border: 0;
    box-shadow: 0px 0px 10px #00000048;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    cursor: pointer;
  }

  iframe {
    border: 0;
  }
}

.transition-anim-enter-active,
.transition-anim-leave-active {
  transition: opacity 0.3s ease-in;
}

.transition-anim-enter,
.transition-anim-leave-to {
  opacity: 0;
}
</style>
